import React, { FC } from 'react'

import { graphql, useStaticQuery } from 'gatsby'

import classes from './plans-carousel.module.scss'
import { usePlansWithFallback } from '../../../../hooks'
import { PlansCarousel as Carousel } from '../../../../modules/components'
import {
  ApiPlanNode,
  mapApiPlanNodesToPlans,
} from '../../../../utils/buildTimePlans'
import { getSlugsFromContentfulPlansCollections } from '../utils'

export const PlansCarousel: FC<Queries.GenericPageSectionFragment> = ({
  items,
  title,
  header,
  selectedItem,
}) => {
  const data = useStaticQuery<{
    allApiPlan?: { nodes: ApiPlanNode[] }
  }>(graphql`
    query PageSectionPlansCarouselApiPlans {
      allApiPlan {
        nodes {
          ...ApiPlanCarouselFields
        }
      }
    }
  `)
  const buildTimePlans = mapApiPlanNodesToPlans(data?.allApiPlan?.nodes ?? [])
  const { slugs, category } = getSlugsFromContentfulPlansCollections(items)
  const defaultPosition = selectedItem ? slugs.indexOf(selectedItem.slug) : 0
  const { list } = usePlansWithFallback(slugs, buildTimePlans)

  if (!slugs.length) {
    return null
  }

  return (
    <div
      data-module-id={category}
      data-module_name={category}
      data-module_placement="plan-list"
    >
      <Carousel
        title={title}
        list={list}
        heading={<div className={classes.header}>{header}</div>}
        dataTestId={category}
        moduleId={category}
        defaultPosition={defaultPosition}
      />
    </div>
  )
}
